import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

@observer
export class Sort extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    children: PropTypes.node,
    property: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    list: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props);
    this.buttonRef = React.createRef();
    this.toggleSort = this.toggleSort.bind(this);
    this.arrowDirection = this.arrowDirection.bind(this);
    this.isActive = this.isActive.bind(this);
  }

  toggleSort() {
    this.props.store.toggleSort({
      list: this.props.list,
      property: this.props.property,
      title: this.props.title
    });
  }

  arrowDirection() {
    let sortKey = this.props.store.activeSort[this.props.list].property;
    if (sortKey === this.props.property) {
      return this.props.store.activeSort[this.props.list].direction === 'asc'
        ? 'arrow-up'
        : 'arrow-down';
    } else {
      return null;
    }
  }

  isActive() {
    let sortKey = this.props.store.activeSort[this.props.list].property;
    return (sortKey === this.props.property)
      ? 'sort-button active'
      : 'sort-button';
  }

  render() {
    return (<button type="button" ref={this.buttonRef} className={this.isActive()} onClick={this.toggleSort}>
      <span className="sr-only">Sort By</span>
      {this.props.children}
      <i className={this.arrowDirection()}/>
    </button>)
  }
}
